import { createContext, useContext, useState, useEffect } from 'react';
import { translations, getBrowserLanguage, languageOptions } from '../i18n/translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first, then browser preference
    const savedLang = localStorage.getItem('preferredLanguage');
    if (savedLang && translations[savedLang]) {
      return savedLang;
    }
    return getBrowserLanguage();
  });

  const [t, setT] = useState(translations[language] || translations.en);

  useEffect(() => {
    // Update translations when language changes
    setT(translations[language] || translations.en);
    // Save to localStorage
    localStorage.setItem('preferredLanguage', language);
    // Update HTML lang attribute
    document.documentElement.lang = language;
  }, [language]);

  const changeLanguage = (langCode) => {
    if (translations[langCode]) {
      setLanguage(langCode);
    }
  };

  const value = {
    language,
    setLanguage: changeLanguage,
    t,
    languageOptions,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

// HOC for class components (if needed)
export function withLanguage(Component) {
  return function WrappedComponent(props) {
    const languageContext = useLanguage();
    return <Component {...props} {...languageContext} />;
  };
}
